import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  createFlashcard,
  getFlashcard,
  deleteFlashcard,
  updateFlashcard,
} from '../../../actions/flashcards.js';
import { getFlashcardTypes } from '../../../actions/flashcardTypes.js';
import { useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { TextField } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import LatexTextField from '../../common/LatexTextField';
import { LatexEditorFormContext } from '../../common/LatexEditorFormContext';
import Switch from '@material-ui/core/Switch';

import { IMAGEPRESENTATION_TYPE_RANDOM } from '../../../constants/flashcardTypes';
import FlashcardformGeneric from './Flashcardforms/FlashcardformGeneric.js';
import {
  enrichFieldsWithType,
  mapFieldsForTargetType,
  deriveHeaderAndSolutionsPatch,
} from './flashcardFieldMigration.js';
import { testIntervals } from '../Flashcardselection.js';

import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    margin: 10,
  },
  buttonClear: {
    margin: 10,
  },
}));

const Flashcardform = ({ flashcardHeaders, currentId, close }) => {
  const flashcard = useSelector((state) => state.flashcard);
  const trainings = useSelector((state) => state.trainings);
  const flashcardTypesFromDb = useSelector((state) => state.flashcardTypes);

  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!flashcardTypesFromDb || flashcardTypesFromDb.length === 0) {
      dispatch(getFlashcardTypes());
    }
  }, []);

  const flashCardTypes =
    flashcardTypesFromDb && flashcardTypesFromDb.length > 0
      ? flashcardTypesFromDb.map((t) => t.name)
      : [];

  const [flashcardData, setFlashcardData] = useState({
    flashcardTypeId: '',
    fields: [],
    syntax: '',
    test: [],
    source: '',
    imagepos: { x: 0, y: 0 },
    dates: {
      format: 'year',
      start: '',
      end: '',
      isrange: false,
    },
    casesensitive: true,
    header: {
      type: '',
      title: '',
      creator: '',
      passlevel: 0,
      trainings: [],
      lastupdated: '',
      lastpass: '',
      lasttest: '',
      created: '',
      active: true,
      attempts: 0,
      soundavailable: false,
    },
    imagepresentationtype: IMAGEPRESENTATION_TYPE_RANDOM,
    inputimages: [],
    solutions: [
      {
        text: '',
        sound: '',
        infotext: '',
        correct: false,
      },
    ],
    solutiontype: '',
  });

  const lastSubmissionSettings = JSON.parse(
    localStorage.getItem('lastSubmissionSettings'),
  );

  const [createAddCard, setCreateAddCard] = useState(
    lastSubmissionSettings !== undefined && lastSubmissionSettings !== null
      ? lastSubmissionSettings.createAddCard
      : true,
  );
  const [sendCard, setSendCard] = useState(false);
  const [updateTimeStamp, setUpdateTimeStamp] = useState(
    lastSubmissionSettings !== undefined && lastSubmissionSettings !== null
      ? lastSubmissionSettings.updateTimeStamp
      : false,
  );

  const [flashCardType, setFlashcardType] = useState(
    flashcardData.header !== undefined && flashcardData._id !== undefined
      ? flashcardData.header.type
      : '',
  );
  const [defaultFlashcardPasslevel, setDefaultFlashcardPasslevel] = useState(
    flashcardData.header !== undefined ? flashcardData.header.passlevel : 0,
  );

  const [defaultTrainingValue, setDefaultTrainingValue] = useState(
    flashcardData.length !== 0 && flashcardData.header.trainings !== undefined
      ? flashcardData.header.trainings
      : undefined,
  );

  const [useLatex, setUseLatex] = useState(false);

  /** Per flashcard type: last field values when leaving that type (until save). */
  const [fieldSnapshotsByTypeId, setFieldSnapshotsByTypeId] = useState({});
  const fieldSnapshotsRef = useRef({});
  useEffect(() => {
    fieldSnapshotsRef.current = fieldSnapshotsByTypeId;
  }, [fieldSnapshotsByTypeId]);

  useEffect(() => {
    if (currentId === 0 && lastSubmissionSettings !== null) {
      setDefaultTrainingValue(lastSubmissionSettings.defaultTrainingValue);
      setFlashcardType(lastSubmissionSettings.flashCardType);
      let header = flashcardData.header;
      header.trainings = lastSubmissionSettings.defaultTrainingValue;
      header.type = lastSubmissionSettings.flashCardType;
      setFlashcardData({
        ...flashcardData,
        header: header,
      });
    }
  }, []);

  useEffect(() => {
    if (currentId !== undefined && currentId !== 0) {
      dispatch(getFlashcard(currentId));
    }
  }, [currentId]);

  useEffect(() => {
    if (currentId !== 0) {
      if (flashcard.header !== undefined) {
        setFlashcardType(flashcard.header.type);
        setDefaultTrainingValue(flashcard.header.trainings);
      }
      setFlashcardData(flashcard);
    }
  }, [flashcard]);

  useEffect(() => {
    if (currentId !== 0 && flashcard?._id) {
      setFieldSnapshotsByTypeId({});
    }
  }, [flashcard?._id, currentId]);

  useEffect(() => {
    if (sendCard) {
      if (currentId === 0) {
        dispatch(createFlashcard(flashcardData));
        clear();
      } else if (flashcardData._id !== undefined) {
        dispatch(updateFlashcard(flashcardData._id, flashcardData));
        clear();
      } else {
        console.warn('Could not update flashcard due to missing id');
      }
      if (!createAddCard) {
        close();
      }
      setSendCard(false);
    }
  }, [sendCard]);

  const flashCardPasslevel =
    flashcardData.header !== undefined &&
    flashcardData.header.passlevel !== undefined
      ? flashcardData.header.passlevel
      : 0;

  const clear = () => {
    setFieldSnapshotsByTypeId({});
    const typeObj = (flashcardTypesFromDb || []).find(
      (t) => t.name === flashcardData.header.type,
    );
    const emptyFields = (typeObj?.fields || []).map((f) => ({
      key: f.key,
      value: f.defaultValue || '',
    }));

    if (createAddCard) {
      setFlashcardData({
        flashcardTypeId: flashcardData.flashcardTypeId || '',
        fields: emptyFields,
        syntax: flashcardData.header.syntax,
        test: [],
        source: '',
        imagepos: { x: 0, y: 0 },
        dates: {
          format: 'year',
          start: '',
          end: '',
          isrange: false,
        },
        casesensitive: true,
        header: {
          type: flashcardData.header.type,
          title: '',
          creator: flashcardData.header.creator,
          passlevel: 0,
          trainings: flashcardData.header.trainings,
          lastupdated: '',
          lastpass: '',
          lasttest: '',
          created: '',
          active: true,
          attempts: 0,
          soundavailable: false,
        },
        imagepresentationtype: IMAGEPRESENTATION_TYPE_RANDOM,
        inputimages: [],
        solutions: [
          {
            text: '',
            sound: '',
            infotext: '',
            correct: false,
          },
        ],
        solutiontype: '',
      });
    } else {
      setFlashcardData({
        flashcardTypeId: '',
        fields: [],
        syntax: '',
        test: [],
        source: '',
        imagepos: { x: 0, y: 0 },
        dates: {
          format: 'year',
          start: '',
          end: '',
          isrange: false,
        },
        casesensitive: true,
        header: {
          type: '',
          title: '',
          creator: '',
          passlevel: 0,
          trainings: '',
          lastupdated: '',
          lastpass: '',
          lasttest: '',
          created: '',
          active: true,
          attempts: 0,
          soundavailable: false,
        },
        imagepresentationtype: IMAGEPRESENTATION_TYPE_RANDOM,
        inputimages: [],
        solutions: [
          {
            text: '',
            sound: '',
            infotext: '',
            correct: false,
          },
        ],
        solutiontype: '',
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSendCard(true);

    localStorage.setItem(
      'lastSubmissionSettings',
      JSON.stringify({
        defaultTrainingValue: defaultTrainingValue,
        flashCardType: flashCardType,
        createAddCard: createAddCard,
        updateTimeStamp: updateTimeStamp,
      }),
    );

    let header = flashcardData.header;
    header.created =
      flashcardData.header.created === '' || updateTimeStamp
        ? new Date().toISOString()
        : flashcardData.header.created;
    header.lastpass =
      flashcardData.header.lastpass === '' || updateTimeStamp
        ? new Date().toISOString()
        : flashcardData.header.lastpass;
    setFlashcardData({
      ...flashcardData,
      header: header,
    });
  };

  const selectedTypeObj = (flashcardTypesFromDb || []).find(
    (t) => t.name === flashCardType,
  );

  let card;
  if (selectedTypeObj) {
    card = (
      <FlashcardformGeneric
        flashcardData={flashcardData}
        setFlashcardData={setFlashcardData}
        handleSubmit={handleSubmit}
        flashcardType={selectedTypeObj}
      />
    );
  } else {
    card = (
      <div>
        <h4>Please select flashcard type!</h4>
      </div>
    );
  }

  let foundDuplicate = false;
  for (let i = 0; i < flashcardHeaders.length; i++) {
    if (
      flashcardData.solutions !== undefined &&
      flashcardData.solutions[0].text !== '' &&
      flashcardData.solutions[0].text <=
        flashcardHeaders[i].solutions[0].text &&
      flashcardData.solutions[0].text ===
        flashcardHeaders[i].solutions[0].text.substr(
          0,
          flashcardData.solutions[0].text.length,
        )
    ) {
      foundDuplicate = true;
    }
  }

  return (
    <div>
      {flashcardData.header !== undefined &&
      flashcardData.header.type !== undefined ? (
        <Dialog open>
          <DialogTitle id="simple-dialog-title">
            {currentId == 0 ? 'Create' : 'Update'} flashcard:
          </DialogTitle>
          {/* https://codesandbox.io/s/xr292j5oq4?file=/src/index.js:312-379 */}
          <Grid container direction="row" spacing={2} style={{ margin: 0 }}>
            <Grid item>Select type of flashcard:</Grid>
            <Grid item>
              <Select
                value={flashCardType}
                onChange={(e) => {
                  const newTypeName = e.target.value;
                  const newTypeObj = (flashcardTypesFromDb || []).find(
                    (t) => t.name === newTypeName,
                  );
                  const prevTypeObj = (flashcardTypesFromDb || []).find(
                    (t) => t.name === flashCardType,
                  );

                  const updatedSnapshots = { ...fieldSnapshotsRef.current };
                  if (prevTypeObj?._id) {
                    updatedSnapshots[prevTypeObj._id] = enrichFieldsWithType(
                      prevTypeObj,
                      flashcardData.fields,
                    );
                  }

                  const enrichedCurrent = enrichFieldsWithType(
                    prevTypeObj,
                    flashcardData.fields,
                  );
                  const enrichedForMapping =
                    newTypeObj?._id && updatedSnapshots[newTypeObj._id]
                      ? updatedSnapshots[newTypeObj._id]
                      : enrichedCurrent;

                  const newFields = mapFieldsForTargetType(
                    newTypeObj,
                    enrichedForMapping,
                  );

                  const { headerPatch, solutions } =
                    deriveHeaderAndSolutionsPatch(
                      newTypeObj?.fields || [],
                      newFields,
                      flashcardData.solutions,
                    );

                  const typeFields = newTypeObj?.fields || [];
                  const hasSoundField = typeFields.some(
                    (f) =>
                      f.role === 'solution' && f.fieldType === 'sound',
                  );

                  let header = {
                    ...flashcardData.header,
                    type: newTypeName,
                    ...headerPatch,
                  };
                  if (headerPatch.title === undefined) {
                    header.title = '';
                  }
                  if (!hasSoundField) {
                    header.soundavailable = false;
                  }

                  setFieldSnapshotsByTypeId(updatedSnapshots);
                  setFlashcardData({
                    ...flashcardData,
                    header,
                    flashcardTypeId: newTypeObj?._id || '',
                    fields: newFields,
                    solutions,
                  });
                  setFlashcardType(newTypeName);
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                {flashCardTypes.map((flashCardType) => (
                  <MenuItem key={flashCardType} value={flashCardType}>
                    {flashCardType}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>

          <div style={{ margin: 8 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={useLatex}
                  onChange={(e) => setUseLatex(e.target.checked)}
                  color="primary"
                  inputProps={{
                    'aria-label':
                      'Use LaTeX: show math toolbar, symbol palette, and preview',
                  }}
                />
              }
              label="Use LaTeX"
              style={{ display: 'block', marginBottom: 8 }}
            />
            <LatexEditorFormContext.Provider value={{ useLatex }}>
            {card}
            <p></p>
            <div>
              Source
              <TextField
                value={flashcardData.source}
                onChange={(e) =>
                  setFlashcardData({
                    ...flashcardData,
                    source: e.target.value,
                  })
                }
                fullWidth
              />
            </div>
            <p></p>
            <div>
              Additional info shown after solving
              <LatexTextField
                value={flashcardData.solutions[0].infotext}
                onChange={(e) => {
                  let solutions = flashcardData.solutions;
                  solutions[0].infotext = e.target.value;
                  setFlashcardData({
                    ...flashcardData,
                    solutions: solutions,
                  });
                }}
                fullWidth
              />
            </div>
            <p></p>
            {foundDuplicate && currentId === 0 ? (
              <p style={{ color: 'red' }}>possiblie duplicate</p>
            ) : (
              <></>
            )}
            <div>
              Training(s) for flashcard
              <Autocomplete
                multiple
                // freeSolo
                id="tags-standard"
                options={trainings
                  .sort((a, b) =>
                    Date.parse(a.lastupdated) < Date.parse(b.lastupdated)
                      ? 1
                      : -1,
                  )
                  .map((training) => training.name)}
                value={defaultTrainingValue}
                onChange={(event, values) => {
                  event.preventDefault();
                  let header = flashcardData.header;
                  header.trainings = values.map((value) => value);
                  setFlashcardData({
                    ...flashcardData,
                    header: header,
                  });
                  setDefaultTrainingValue(header.trainings);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label=""
                    placeholder="select training name"
                  />
                )}
              />
            </div>
            <p></p>
            <Grid
              container
              direction="column"
              spacing={0}
              style={{ margin: 0 }}
            >
              <Grid item>
                <Checkbox
                  checked={flashcardData.casesensitive}
                  onChange={(e) => {
                    setFlashcardData({
                      ...flashcardData,
                      casesensitive: e.target.checked,
                    });
                  }}
                />
                case sensitive
              </Grid>
              <Grid item>
                <Checkbox
                  checked={createAddCard}
                  onChange={(e) => {
                    setCreateAddCard(e.target.checked);
                  }}
                />
                create another
              </Grid>
              <Grid item>
                <Checkbox
                  checked={updateTimeStamp}
                  onChange={(e) => {
                    setUpdateTimeStamp(e.target.checked);
                  }}
                />
                update timestamp
              </Grid>
              <Grid item>
                <Switch
                  checked={flashcardData.header.active}
                  onChange={(e) => {
                    let header = flashcardData.header;
                    header.active = e.target.checked;
                    setFlashcardData({
                      ...flashcardData,
                      header: header,
                    });
                  }}
                />
                active
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2} style={{ margin: 0 }}>
              <Grid item>Select learning interval:</Grid>
              <Grid item>
                <Select
                  value={testIntervals[flashCardPasslevel]}
                  onChange={(e) => {
                    let header = flashcardData.header;
                    header.passlevel = testIntervals.indexOf(e.target.value);
                    setFlashcardData({
                      ...flashcardData,
                      header: header,
                    });
                    setDefaultFlashcardPasslevel(header.passlevel);
                  }}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {testIntervals.map((interval) => (
                    <MenuItem key={interval} value={interval}>
                      {interval}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
            <Button
              className={classes.buttonSubmit}
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
              onClick={(e) => {
                handleSubmit(e);
              }}
            >
              {currentId == 0 ? 'Submit' : 'Update'}
            </Button>
            <Button
              onClick={clear}
              className={classes.buttonClear}
              variant="contained"
              color="secondary"
              size="small"
              fullWidth
            >
              Clear
            </Button>
            {currentId == 0 ? (
              []
            ) : (
              <Button
                onClick={() => {
                  dispatch(deleteFlashcard(flashcardData._id));
                  close();
                }}
                className={classes.buttonClear}
                variant="contained"
                color="secondary"
                size="small"
                fullWidth
              >
                Delete
              </Button>
            )}
            <Button
              onClick={close}
              className={classes.buttonClear}
              variant="contained"
              color="secondary"
              size="small"
              fullWidth
            >
              Close
            </Button>
            </LatexEditorFormContext.Provider>
          </div>
        </Dialog>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Flashcardform;
